import { CERTIFICATIONS } from "@/lib/site-data";
import { ShieldCheck, PackageCheck, Scale, Sprout, Thermometer, ClipboardCheck } from "lucide-react";

export default function Quality() {
  const steps = [
    { icon: Sprout, title: "Sourcing", desc: "Handpicked from trusted farms across India." },
    { icon: ClipboardCheck, title: "Inspection", desc: "Every batch goes through rigorous inspection." },
    { icon: Scale, title: "Sorting & Grading", desc: "Sorted and graded by size and quality." },
    { icon: Thermometer, title: "Cold Storage", desc: "Stored in temperature-controlled facilities." },
    { icon: PackageCheck, title: "Packing", desc: "Hygienic packing to preserve freshness." },
    { icon: ShieldCheck, title: "Dispatch", desc: "Safe, secure and timely global dispatch." },
  ];

  return (
    <div>
      <section className="bg-sky-50/60 py-14">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-sm font-semibold tracking-widest text-[#1e5ba8]">QUALITY</p>
          <h1 className="font-display font-bold text-5xl sm:text-6xl text-[#0f172a] mt-3 tracking-tight">Quality You Can Trust</h1>
          <p className="text-slate-600 mt-4 max-w-2xl">
            We follow international quality standards and strict food safety practices at every step.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h2 className="font-display font-bold text-3xl text-[#0f172a] mb-8">Our Quality Process</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {steps.map((s, i) => (
            <div key={s.title} className="bg-white border border-slate-200 rounded-xl p-6 hover:-translate-y-1 hover:shadow-lg transition-transform duration-200">
              <div className="flex items-center gap-3">
                <div className="w-11 h-11 rounded-md bg-sky-50 text-[#1e5ba8] flex items-center justify-center">
                  <s.icon className="w-5 h-5" />
                </div>
                <div className="text-xs font-bold text-[#1e5ba8]">STEP 0{i + 1}</div>
              </div>
              <h3 className="font-display font-bold text-lg mt-4">{s.title}</h3>
              <p className="text-sm text-slate-600 mt-2">{s.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-slate-50/70 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-display font-bold text-3xl text-[#0f172a] mb-8">Our Certifications</h2>
          <div className="flex flex-wrap gap-6">
            {CERTIFICATIONS.map((c) => (
              <div key={c.name} className="flex flex-col items-center gap-2 min-w-[140px] bg-white p-5 rounded-xl border border-slate-200">
                <div className="w-16 h-16 rounded-full border-2 border-[#1e5ba8] flex items-center justify-center bg-white">
                  <span className="font-display font-bold text-[10px] text-[#1e5ba8] text-center leading-tight px-1">{c.short}</span>
                </div>
                <div className="text-xs text-slate-600 text-center leading-tight">{c.name}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
